import api from '@/api';
import { API_BASE_URL } from '..';
import {
  ReportWorkOrderQuotationMapRequest,
  ReportWorkOrderSoldHoursRequest,
} from './WorkOrder.types';

const baseUrl = API_BASE_URL;

// WorkOrder
export async function generateWorkOrderSoldHours(
  params?: ReportWorkOrderSoldHoursRequest,
) {
  const result = (await api.getReport(
    `${baseUrl}/WorkOrder/SoldHours`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateQuotationMap(
  params?: ReportWorkOrderQuotationMapRequest,
) {
  const result = (await api.getReport(
    `${baseUrl}/WorkOrder/QuotationMap`,
    params,
  )) as unknown;

  return result as BlobPart;
}
